<!-- <div class="min-h-screen bg-slate-50 p-4">
    <div class="max-w-6xl mx-auto space-y-4">

        <div class="bg-white rounded-lg shadow-sm border border-slate-200 p-4">
            <div class="flex items-center justify-between">
                
                <div>
                    <h2 class="text-lg font-semibold text-slate-800">
                        List Column Config
                    </h2>
                    <p class="text-xs text-slate-500">
                        Manage list column metadata
                    </p>
                </div>

                <div class="flex items-center gap-3">
                    
                    <div class="relative">
                        <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                            <svg class="h-4 w-4 text-slate-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                            </svg>
                        </div>
                        <input type="text" [(ngModel)]="searchTerm" (input)="filter()" placeholder="Search..." 
                            class="w-44 pl-9 pr-3 py-1.5 text-sm border border-slate-300 rounded-md focus:outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500" />
                    </div>

                    <button (click)="openCreate()" class="bg-blue-600 hover:bg-blue-700 text-white px-4 py-1.5 text-sm rounded-md font-medium">
                        + Create Column
                    </button>
                </div>
            </div>
        </div>

        <div class="bg-white rounded-lg shadow-sm border border-slate-200 overflow-hidden">
            <div class="overflow-x-auto">
                <table class="w-full text-sm">
                    
                    <thead>
                        <tr class="bg-slate-50 border-b border-slate-200 text-slate-500 uppercase text-[11px]">
                            <th class="px-3 py-2 text-left">Entity</th>
                            <th class="px-3 py-2 text-left">Field</th>
                            <th class="px-3 py-2 text-left">Label</th>
                            <th class="px-3 py-2 text-center">Visible</th>
                            <th class="px-3 py-2 text-center">Sortable</th>
                            <th class="px-3 py-2 text-center">Seq</th>
                            <th class="px-3 py-2 text-left">Value Source</th>
                            <th class="px-3 py-2 text-left">Filter</th>
                            <th class="px-3 py-2 text-left">Relation</th>
                            <th class="px-3 py-2 text-right">Actions</th>
                        </tr>
                    </thead>

                    <tbody class="divide-y divide-slate-100">
                        <tr *ngFor="let c of filteredConfigs" class="hover:bg-slate-50">
                            
                            <td class="px-3 py-2 font-medium text-slate-700">
                                {{ c.entity }}
                            </td>
                            
                            <td class="px-3 py-2 font-mono text-slate-600">
                                {{ c.field }}
                            </td>
                            
                            <td class="px-3 py-2 text-slate-600">
                                {{ c.label }}
                            </td>

                            <td class="py-3 px-4 text-center">
                                <div class="flex items-center justify-center gap-1.5">
                                    <span class="relative inline-flex rounded-full h-2 w-2"
                                          [ngClass]="c.isVisible ? 'bg-emerald-500' : 'bg-slate-300'"></span>
                                    <span class="text-xs font-medium"
                                          [class.text-slate-400]="!c.isVisible"
                                          [class.text-slate-700]="c.isVisible">
                                        {{ c.isVisible ? 'Yes' : 'No' }}
                                    </span>
                                </div>
                            </td>

                            <td class="py-3 px-4 text-center">
                                <div class="flex items-center justify-center gap-1.5">
                                    <span class="relative inline-flex rounded-full h-2 w-2"
                                          [ngClass]="c.isSortable ? 'bg-emerald-500' : 'bg-slate-300'"></span>
                                    <span class="text-xs font-medium"
                                          [class.text-slate-400]="!c.isSortable"
                                          [class.text-slate-700]="c.isSortable">
                                        {{ c.isSortable ? 'Yes' : 'No' }}
                                    </span>
                                </div>
                            </td>

                            <td class="px-3 py-2 text-center text-slate-600">
                                {{ c.seq }}
                            </td>
                            
                            <td class="px-3 py-2">
                                <span class="px-2 py-0.5 rounded bg-slate-100 text-slate-700 text-xs">
                                    {{ c.valueSource }}
                                </span>
                            </td>

                            <td class="px-3 py-2 text-slate-500">
                                {{ c.filterType || '-' }}
                            </td>

                            <td class="px-3 py-2 text-slate-500 text-xs">
                                <ng-container *ngIf="c.relationEntity || c.relationField; else noRelation">
                                    <span class="font-medium text-slate-600">{{ c.relationEntity || '-' }}</span>
                                    <span class="text-slate-400 mx-1">/</span> 
                                    <span>{{ c.relationField || '-' }}</span>
                                </ng-container>
                                <ng-template #noRelation>-</ng-template>
                            </td>

                            <td class="py-3 px-4 text-right">
                                <div class="flex items-center justify-end gap-3">
                                    <button (click)="openEdit(c)" class="text-slate-400 hover:text-blue-600 transition-colors" title="Edit">
                                        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z"></path>
                                        </svg>
                                    </button>
                                    <button (click)="delete(c.id)" class="text-slate-400 hover:text-red-600 transition-colors" title="Delete">
                                        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"></path>
                                        </svg>
                                    </button>
                                </div>
                            </td>

                        </tr>

                        <tr *ngIf="filteredConfigs.length === 0">
                            <td colspan="10" class="py-8 text-center text-slate-400">
                                No column configurations found
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
      
            <div
                class="kt-card-footer flex flex-wrap items-center justify-between gap-4 px-4 py-2.5 bg-white border-t border-slate-200 text-xs font-medium">
                <div class="flex items-center gap-3 text-sm font-bold text-black-600">
                    <span>Show</span>
                    <select [value]="pageSize" (change)="changePageSize($event)"
                        class="kt-select w-20 border-2 border-slate-200 rounded-lg px-3 py-2 bg-white text-slate-800 font-bold outline-none focus:border-blue-500 transition-all cursor-pointer shadow-sm text-sm">
                        <option [value]="5">5</option>
                        <option [value]="10">10</option>
                        <option [value]="25">25</option>
                        <option [value]="50">50</option>
                    </select>
                    <span>per page</span>
                </div>
                <div class="flex items-center gap-6 text-black-600 font-medium">
                    <span class="hidden sm:inline-block text-sm">
                        {{ pageIndex * pageSize + 1 }}-{{ (pageIndex + 1) * pageSize > total ? total : (pageIndex + 1) * pageSize }}
                        of {{ total }}
                    </span>
            
                    <div class="flex items-center gap-2">
                        <button (click)="goToPage(pageIndex - 1)" [disabled]="pageIndex === 0"
                            class="w-9 h-9 flex items-center justify-center rounded border border-slate-300 bg-white hover:bg-slate-100 disabled:opacity-30 disabled:hover:bg-transparent transition-colors shadow-sm text-slate-600">
                            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"></path>
                            </svg>
                        </button>
            
                        <div
                            class="w-9 h-9 flex items-center justify-center bg-slate-100 border border-slate-200 rounded text-slate-900 font-bold text-sm shadow-inner">
                            {{ pageIndex + 1 }}
                        </div>
            
                        <button (click)="goToPage(pageIndex + 1)" [disabled]="pageIndex >= totalPages - 1"
                            class="w-9 h-9 flex items-center justify-center rounded border border-slate-300 bg-white hover:bg-slate-100 disabled:opacity-30 disabled:hover:bg-transparent transition-colors shadow-sm text-slate-600">
                            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"></path>
                            </svg>
                        </button>
                    </div>
                </div>
            </div>
          
      </div>
    </div>
</div> -->

<div class="min-h-screen bg-slate-50 p-4">
    <div class="max-w-6xl mx-auto space-y-4">
        <div class="bg-white rounded-lg shadow-sm border border-slate-200 p-4">
            <div class="flex items-center justify-between">
                <div>
                    <h2 class="text-lg font-semibold text-slate-800">List Column Config</h2>
                    <p class="text-xs text-slate-500">Manage list column metadata</p>
                </div>
                <div class="flex items-center gap-3">
                    <div class="relative">
                        <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                            <svg class="h-4 w-4 text-slate-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                            </svg>
                        </div>
                        <input [(ngModel)]="searchTerm" (keyup.enter)="onSearch()" placeholder="Search..."
                            class="w-44 pl-9 pr-3 py-1.5 text-sm border border-slate-300 rounded-md focus:outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500" />
                    </div>
                    <button (click)="openCreate()"
                        class="bg-blue-600 hover:bg-blue-700 text-white px-4 py-1.5 text-sm rounded-md font-medium">+
                        Create Column</button>
                </div>
            </div>
        </div>

        <div class="bg-white rounded-lg shadow-sm border border-slate-200 overflow-hidden">
            <div class="overflow-x-auto">
                <table class="w-full text-sm">
                    <thead>
                        <tr class="bg-slate-50 border-b border-slate-200 text-slate-500 uppercase text-[11px]">
                            <th class="px-3 py-2 text-left">Entity</th>
                            <th class="px-3 py-2 text-left">Field</th>
                            <th class="px-3 py-2 text-left">Label</th>
                            <th class="px-3 py-2 text-center">Visible</th>
                            <th class="px-3 py-2 text-center">Sortable</th>
                            <th class="px-3 py-2 text-center">Seq</th>
                            <th class="px-3 py-2 text-left">Value Source</th>
                            <th class="px-3 py-2 text-left">Filter</th>
                            <th class="px-3 py-2 text-left">Relation</th>
                            <th class="px-3 py-2 text-right">Actions</th>
                        </tr>
                    </thead>
                    <tbody class="divide-y divide-slate-100">
                        <tr *ngFor="let c of configs" class="hover:bg-slate-50">
                            <td class="px-3 py-2 font-medium text-slate-700">{{ c.entity }}</td>
                            <td class="px-3 py-2 font-mono text-slate-600">{{ c.field }}</td>
                            <td class="px-3 py-2 text-slate-600">{{ c.label }}</td>
                            <td class="py-3 px-4 text-center">
                                <div class="flex items-center justify-center gap-1.5">
                                    <span class="relative inline-flex rounded-full h-2 w-2"
                                        [ngClass]="c.isVisible ? 'bg-emerald-500' : 'bg-slate-300'"></span>
                                    <span class="text-xs font-medium" [class.text-slate-400]="!c.isVisible"
                                        [class.text-slate-700]="c.isVisible">{{ c.isVisible ? 'Yes' : 'No' }}</span>
                                </div>
                            </td>
                            <td class="py-3 px-4 text-center">
                                <div class="flex items-center justify-center gap-1.5">
                                    <span class="relative inline-flex rounded-full h-2 w-2"
                                        [ngClass]="c.isSortable ? 'bg-emerald-500' : 'bg-slate-300'"></span>
                                    <span class="text-xs font-medium" [class.text-slate-400]="!c.isSortable"
                                        [class.text-slate-700]="c.isSortable">{{ c.isSortable ? 'Yes' : 'No' }}</span>
                                </div>
                            </td>
                            <td class="px-3 py-2 text-center text-slate-600">{{ c.seq }}</td>
                            <td class="px-3 py-2">
                                <span class="px-2 py-0.5 rounded bg-slate-100 text-slate-700 text-xs">{{ c.valueSource
                                    }}</span>
                            </td>
                            <td class="px-3 py-2 text-slate-500">{{ c.filterType || '-' }}</td>
                            <td class="px-3 py-2 text-slate-500 text-xs">
                                <ng-container *ngIf="c.relationEntity || c.relationField; else noRelation">
                                    <span class="font-medium text-slate-600">{{ c.relationEntity || '-' }}</span>
                                    <span class="text-slate-400 mx-1">/</span>
                                    <span>{{ c.relationField || '-' }}</span>
                                </ng-container>
                                <ng-template #noRelation>-</ng-template>
                            </td>
                            <td class="py-3 px-4 text-right">
                                <div class="flex items-center justify-end gap-3">
                                    <button (click)="openEdit(c)"
                                        class="text-slate-400 hover:text-blue-600 transition-colors"><svg
                                            class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                                d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z">
                                            </path>
                                        </svg></button>
                                    <button (click)="delete(c.id)"
                                        class="text-slate-400 hover:text-red-600 transition-colors"><svg class="w-4 h-4"
                                            fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                                d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16">
                                            </path>
                                        </svg></button>
                                </div>
                            </td>
                        </tr>
                        <tr *ngIf="configs.length === 0">
                            <td colspan="10" class="py-8 text-center text-slate-400">No column configurations found</td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div
                class="kt-card-footer flex flex-wrap items-center justify-between gap-4 px-4 py-2.5 bg-white border-t border-slate-200 text-xs font-medium">
                <div class="flex items-center gap-3 text-sm font-bold text-black-600">
                    <span>Show</span>
                    <select [value]="pageSize" (change)="changePageSize($event)"
                        class="kt-select w-20 border-2 border-slate-200 rounded-lg px-3 py-2 bg-white text-slate-800 font-bold outline-none focus:border-blue-500 transition-all cursor-pointer shadow-sm text-sm">
                        <option [value]="5">5</option>
                        <option [value]="10">10</option>
                        <option [value]="25">25</option>
                        <option [value]="50">50</option>
                    </select>
                    <span>per page</span>
                </div>
                <div class="flex items-center gap-6 text-black-600 font-medium">
                    <!-- <span class="hidden sm:inline-block text-sm">
                        {{ pageIndex * pageSize + 1 }}-{{ (pageIndex + 1) * pageSize > total ? total : (pageIndex + 1) *
                        pageSize }}
                        of {{ total }}
                    </span> -->
                    <span class="hidden sm:inline-block text-sm">
                        {{ pageIndex * pageSize + 1 }}-{{ (pageIndex + 1) * pageSize > total ? total : (pageIndex + 1) *
                        pageSize }}
                        of {{ total }}
                    </span>
                    <div class="flex items-center gap-2">
                        <button (click)="goToPage(pageIndex - 1)" [disabled]="pageIndex === 0"
                            class="w-9 h-9 flex items-center justify-center rounded border border-slate-300 bg-white hover:bg-slate-100 disabled:opacity-30 disabled:hover:bg-transparent transition-colors shadow-sm text-slate-600">
                            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M15 19l-7-7 7-7"></path>
                            </svg>
                        </button>
                        <div
                            class="w-9 h-9 flex items-center justify-center bg-slate-100 border border-slate-200 rounded text-slate-900 font-bold text-sm shadow-inner">
                            {{ pageIndex + 1 }}
                        </div>
                        <button (click)="goToPage(pageIndex + 1)" [disabled]="pageIndex >= totalPages - 1"
                            class="w-9 h-9 flex items-center justify-center rounded border border-slate-300 bg-white hover:bg-slate-100 disabled:opacity-30 disabled:hover:bg-transparent transition-colors shadow-sm text-slate-600">
                            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7">
                                </path>
                            </svg>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div *ngIf="isModalOpen" class="fixed inset-0 z-50 flex items-center justify-center bg-black/40">

    <div class="bg-white rounded-lg shadow-xl w-full max-w-xl p-5 space-y-4">

        <div class="flex justify-between items-center">
            <h3 class="text-base font-semibold text-slate-800">
                {{ isEditMode ? 'Edit' : 'Create' }} Column
            </h3>
            <button (click)="close()" class="text-gray-400 hover:text-gray-600 text-sm transition-colors">✕</button>
        </div>

        <div class="grid grid-cols-2 gap-3 text-sm">

            <div>
                <label class="text-xs text-slate-500 mb-1 block">Entity</label>
                <input [(ngModel)]="current.entity"
                    class="w-full border border-slate-300 rounded px-2 py-1.5 focus:outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500">
            </div>

            <div>
                <label class="text-xs text-slate-500 mb-1 block">Field</label>
                <input [(ngModel)]="current.field"
                    class="w-full border border-slate-300 rounded px-2 py-1.5 focus:outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500">
            </div>

            <div>
                <label class="text-xs text-slate-500 mb-1 block">Label</label>
                <input [(ngModel)]="current.label"
                    class="w-full border border-slate-300 rounded px-2 py-1.5 focus:outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500">
            </div>

            <div>
                <label class="text-xs text-slate-500 mb-1 block">Value Source</label>
                <input [(ngModel)]="current.valueSource"
                    class="w-full border border-slate-300 rounded px-2 py-1.5 focus:outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500">
            </div>

            <div>
                <label class="text-xs text-slate-500 mb-1 block">Width</label>
                <input type="number" [(ngModel)]="current.width"
                    class="w-full border border-slate-300 rounded px-2 py-1.5 focus:outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500">
            </div>

            <div>
                <label class="text-xs text-slate-500 mb-1 block">Sequence</label>
                <input type="number" [(ngModel)]="current.seq"
                    class="w-full border border-slate-300 rounded px-2 py-1.5 focus:outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500">
            </div>

            <div>
                <label class="text-xs text-slate-500 mb-1 block">Filter Type</label>
                <input [(ngModel)]="current.filterType"
                    class="w-full border border-slate-300 rounded px-2 py-1.5 focus:outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500">
            </div>

            <div>
                <label class="text-xs text-slate-500 mb-1 block">Relation Entity</label>
                <input [(ngModel)]="current.relationEntity"
                    class="w-full border border-slate-300 rounded px-2 py-1.5 focus:outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500">
            </div>

            <div class="col-span-2">
                <label class="text-xs text-slate-500 mb-1 block">Relation Field</label>
                <input [(ngModel)]="current.relationField"
                    class="w-full border border-slate-300 rounded px-2 py-1.5 focus:outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500">
            </div>

            <div class="col-span-2 flex gap-6 mt-1">
                <label class="flex items-center gap-2 text-sm text-slate-700 cursor-pointer">
                    <input type="checkbox" [(ngModel)]="current.isVisible"
                        class="rounded border-slate-300 text-blue-600 focus:ring-blue-500">
                    Visible
                </label>

                <label class="flex items-center gap-2 text-sm text-slate-700 cursor-pointer">
                    <input type="checkbox" [(ngModel)]="current.isSortable"
                        class="rounded border-slate-300 text-blue-600 focus:ring-blue-500">
                    Sortable
                </label>
            </div>

        </div>

        <div class="flex justify-end gap-2 pt-3 mt-2 border-t border-slate-100">
            <button (click)="close()"
                class="px-4 py-1.5 border border-slate-300 text-slate-700 rounded-md text-sm hover:bg-slate-50 transition-colors">
                Cancel
            </button>
            <button (click)="save()"
                class="px-4 py-1.5 bg-blue-600 hover:bg-blue-700 text-white rounded-md text-sm font-medium transition-colors">
                {{ isEditMode ? 'Update' : 'Save' }}
            </button>
        </div>

    </div>
</div>